import type React from 'react';
import { Icon } from '@squareup/shared-ui-react';

const Message: React.FC = () => (
  <Icon iconName="message" />
);

export default Message;
